import React from 'react';
import Services from './Services';

const ServiceCategories = () => {
  // Remove the 'filter' prop since 'Services' does not accept it
  return <Services />;
};

export default ServiceCategories;
